<template>
  <div class="doll-root">
    <img
      v-for="(src, key) in srcMap"
      class="main-images"
      :key="key"
      :src="src"
      :class="{ show: status === key, wide: isWide }"
      :alt="key"
    />
    <img v-show="completed" class="complete-icon" src="../../assets/ScanBody/complete.svg" />
  </div>
</template>

<script>
import relaxed from '@/assets/DollWithHandles/relaxed.svg';
import fist from '@/assets/DollWithHandles/fist.svg';
import focusGrip from '@/assets/DollWithHandles/focus_grip.svg';
import focusLetgo from '@/assets/DollWithHandles/focus_letgo.svg';
import scanningFist from '@/assets/DollWithHandles/scanning_fist.svg';
import scanningGrip from '@/assets/DollWithHandles/scanning_grip.svg';

const srcMap = {
  relaxed,
  fist,
  focusGrip,
  focusLetgo,
  scanningFist,
  scanningGrip,
};

export default {
  name: 'DollWithHandles',
  props: {
    status: String,
    completed: Boolean,
  },
  computed: {
    srcMap() {
      return srcMap;
    },
    isWide() {
      return this.status.indexOf('focus') === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.doll-root {
  @apply relative flex justify-center items-center;
  .main-images {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 340px;
    opacity: 0;
    &.show {
      opacity: 1;
    }
    &.wide {
      min-width: 418px;
    }
    @screen xs {
      min-width: 200px;
      &.wide {
        min-width: 245px;
      }
    }
  }
  .complete-icon {
    z-index: 10;
  }
}
</style>
